import { bindPointerDragReorder } from '../shared/pointer-drag-reorder.js';

function initDataGridDragReorder(opts) {
    const {
        body,
        itemSelector,
        onReorder,
        allowReinit = false,
        handleSelector = null,
    } = opts;

    if (!body || !itemSelector || typeof onReorder !== 'function') return;
    if (body._dataGridDragReorderInit && !allowReinit) return;
    if (body._dataGridDragReorderAbort) body._dataGridDragReorderAbort.abort();
    body._dataGridDragReorderInit = true;

    const ac = new AbortController();
    body._dataGridDragReorderAbort = ac;
    const signal = ac.signal;

    let draggedItem = null;
    let orderChanged = false;
    let dragRowRects = null;

    function moveItemSilent(container, dragged, ref) {
        if (ref === dragged || dragged.nextSibling === ref) return false;
        container.insertBefore(dragged, ref);
        return true;
    }

    function captureDragRowRects() {
        const rows = Array.from(body.querySelectorAll(itemSelector)).filter((row) => row !== draggedItem);
        dragRowRects = rows.map((row) => ({ row, rect: row.getBoundingClientRect() }));
    }

    function reorderDraggedAtY(clientY) {
        if (!draggedItem) return;
        if (!dragRowRects) captureDragRowRects();
        if (dragRowRects.length === 0) return;

        let ref = dragRowRects[dragRowRects.length - 1].row.nextSibling;
        for (let i = 0; i < dragRowRects.length; i += 1) {
            const { row, rect } = dragRowRects[i];
            const midpoint = rect.top + (rect.height / 2);
            if (clientY < midpoint) {
                ref = row;
                break;
            }
        }

        if (moveItemSilent(draggedItem.parentNode, draggedItem, ref)) {
            orderChanged = true;
            captureDragRowRects();
        }
    }

    function isReorderDisabled() {
        return !!(body.closest('form.manager-form-readonly')
            || body.closest('.manager-form-readonly')
            || body.dataset.reorderDisabled === '1');
    }

    body.classList.toggle('data-grid-body--drag-reorder', !isReorderDisabled());

    if (isReorderDisabled()) return;

    bindPointerDragReorder({
        root: body,
        itemSelector,
        handleSelector,
        signal,
        onActivate: (item) => {
            draggedItem = item;
            orderChanged = false;
            dragRowRects = null;
        },
        onMove: (item, point) => {
            draggedItem = item;
            reorderDraggedAtY(point.y);
        },
        onEnd: () => {
            draggedItem = null;
            dragRowRects = null;
            if (orderChanged) {
                orderChanged = false;
                onReorder();
            }
        },
    });
}

export { initDataGridDragReorder };
